import { Zap, Globe, Hash } from 'lucide-react';

export function CrmSources({ nafCodes }) {
  const sources = [
    { name: 'INSEE Sirene', desc: 'Base officielle \u2014 filtrage par code NAF, departement, effectif', prix: 'Gratuit (API publique)', color: '#3B82F6', status: 'bientot' },
    { name: 'Google Maps Places', desc: 'Recherche locale avec avis, horaires, telephone', prix: 'Freemium', color: '#10B981', status: 'bientot' },
    { name: 'Hunter.io', desc: 'Emails pro par nom de domaine', prix: '25 rech./mois gratuit', color: '#EF4444', status: 'bientot' },
    { name: 'Apollo.io', desc: 'Base 270M contacts B2B', prix: '50 credits/mois', color: '#F59E0B', status: 'bientot' },
    { name: 'Pages Jaunes / Societe.com', desc: 'Annuaire pro + donnees legales', prix: 'Gratuit', color: '#6366F1', status: 'bientot' },
  ];

  return (
    <div className="space-y-3" data-testid="crm-sources">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-4">
        <div className="flex items-center gap-2 mb-1"><Zap size={14} className="text-blue-500" /><p className="text-xs font-bold text-blue-700">Sources de prospection</p></div>
        <p className="text-[10px] text-blue-600">APIs bientot connectees. Recherche actuelle: donnees simulees.</p>
      </div>

      {sources.map((s, i) => (
        <div key={i} className="bg-white rounded-xl border p-4" data-testid={`source-${i}`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: s.color + '15' }}><Globe size={16} style={{ color: s.color }} /></div>
              <div><p className="text-sm font-bold text-gray-900">{s.name}</p><p className="text-[10px] text-gray-500">{s.desc}</p><p className="text-[10px] text-gray-300 mt-0.5">{s.prix}</p></div>
            </div>
            <span className="text-[9px] px-2.5 py-1 rounded-full bg-yellow-50 text-yellow-600 font-medium">Bientot</span>
          </div>
        </div>
      ))}

      <div className="bg-white rounded-xl border p-4" data-testid="naf-codes">
        <div className="flex items-center gap-2 mb-3"><Hash size={14} className="text-[#3B82F6]" /><h3 className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Codes NAF INSEE Sirene</h3></div>
        <p className="text-[10px] text-gray-500 mb-3">Ces codes permettront de filtrer les entreprises par activite sur l'API INSEE Sirene :</p>
        <div className="grid grid-cols-1 gap-1">
          {Object.entries(nafCodes || {}).map(([key, naf]) => (
            <div key={key} className="flex items-center justify-between py-1.5 px-2 rounded hover:bg-gray-50 border-b border-gray-50">
              <span className="text-xs text-gray-700">{naf.label}</span>
              <span className="text-[10px] font-mono bg-blue-50 text-blue-600 px-2 py-0.5 rounded">{naf.code}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
